import { AppDispatch } from "modules/shared/infrastructure/redux/auditStore";
import { useDispatch } from "react-redux";

export const useAppDispatch = () => useDispatch<AppDispatch>();
